import { authHeader } from '@/_helpers';

export const creditNoteService = {
    newCreditNote,
    getAll,
    getCreditNoteById,
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function newCreditNote(client_id, amount, description, taxable) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ client_id, amount, description, taxable }),
    };

    return fetch(`${apiUrl}/credit-note/`, requestOptions).then(handleResponse);
}

function getAll(filters, cantPerPage, currentPage, getTotal) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ filters, cantPerPage, currentPage, getTotal }),
    };

    return fetch(`${apiUrl}/credit-note/filtered-list`, requestOptions).then(handleResponse);
}

function getCreditNoteById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };

    return fetch(`${apiUrl}/credit-note/${id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}